import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mothership_logo.webp")